import type { CustomProduct } from "@apptus/esales-api";

export function getProductFlags(product: CustomProduct) {
  const flags = new Set(
    [
      product.custom?.productFlags,
      product.custom?.variantFlags,
      product.custom?.statuses,
    ]
      .flat()
      .map((flag) => flag?.id),
  );

  return [...flags.values()].filter(Boolean) as string[];
}

export function getProductCode(product: CustomProduct) {
  return product.custom?.productCode?.[0]?.id;
}

export function getBrandCode(product: CustomProduct) {
  return product.custom?.brandCode?.[0]?.id;
}

export function getDesignerCodes(product: CustomProduct) {
  return (
    product.custom?.designerCode?.map((code) => code.id).filter(Boolean) ?? []
  );
}

export function getDesignerName(product: CustomProduct) {
  return product.custom?.designerName?.[0]?.id;
}

export function getSampleFamily(product: CustomProduct) {
  return product.custom?.sample_family?.[0]?.id;
}

export function getSeriesCode(product: CustomProduct) {
  return product.custom?.seriesCode?.[0]?.id;
}

export function getStockStatus(product: CustomProduct) {
  return product.custom?.stockStatus?.[0]?.id ?? "Unknown";
}

export function getItemStatus(product: CustomProduct) {
  return product.custom?.itemStatus?.[0]?.id;
}

export function getNextDeliveryDate(product: CustomProduct) {
  const value = product.custom?.nextDeliveryDate?.[0]?.id;
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function getLightsourceQuantity(product: CustomProduct) {
  return product.typedCustom?.numbers?.norce_light_source_quantity ?? 1;
}

export function getStockOnHand(product: CustomProduct) {
  return product.typedCustom?.numbers?.stockOnHand;
}

export function getVariantKey(product: CustomProduct) {
  return product.variants[0]?.key ?? product.key;
}

export function getProductLink(product: CustomProduct) {
  return product.variants[0]?.link ?? product.link;
}

export function getBreadcrumbCodes(product: CustomProduct) {
  return (
    product.custom?.breadcrumbsCode_NG
      ?.map((code) => code.id)
      .filter(Boolean) ?? []
  );
}
